module.exports = __webpack_public_path__ + "static/labs-group-sp24-279516c6e278d04969c9efa15587dd52.jpg";